const NetgsmChannelMenuTypes = {
    CHANNEL: {
        id: "detail",
        group: "settings_group",
        path: "detail",
        label: "Detail",
        tabs: [],
        implemented: true,
    },
    SEND_SMS: {
        id: "netgsmMessage",
        group: "message_group",
        path: "netgsmMessage",
        label: "netgsmMessage",
        tabs: [],
        implemented: true,
    },
};

export default NetgsmChannelMenuTypes;
